import React, { Component } from "react";
import { connect } from "react-redux";
import MetisMenu from "react-metismenu";
import { setOffcanvas } from "../../actions/settingsAction";
import { baseMenu, allMenuItems, restrictedIds, nonRestrictedIds } from "./metisMenu";
import DefaultLink from "./DefaultLink";
import { setMiniSidebarMenuOn, setMiniHover } from "../../actions/settingsAction";
import { ROUTE_BASE_URL } from "../../api/common";
import MenuHeader from "./MunuHeader";

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdown: false,
      metisMenu: [],
    };
    this.toggleSubMenu = this.toggleSubMenu.bind(this);
    this.minisidebarMouseOver = this.minisidebarMouseOver.bind(this);
    this.minisidebarMouseOut = this.minisidebarMouseOut.bind(this);
  }

  isOnRestrictedPages = () => {
    const currentPath = window.location.pathname;

    if (currentPath === ROUTE_BASE_URL || currentPath === `${ROUTE_BASE_URL}/`) {
      return true;
    }

    return (
      currentPath.includes(`${ROUTE_BASE_URL}/admin-team`) ||
      currentPath.includes(`${ROUTE_BASE_URL}/event-management`) ||
      currentPath.includes(`${ROUTE_BASE_URL}/my-profile`) ||
      currentPath.includes(`${ROUTE_BASE_URL}/roles-and-permission`) ||
      currentPath.includes(`${ROUTE_BASE_URL}/access-denied`) ||
      currentPath.includes(`${ROUTE_BASE_URL}/events-dashboard`)
    );
  };

  updateMenuItems = () => {
    let mainItems = [];
    let configureItems = [];

    if (this.isOnRestrictedPages()) {
      mainItems = allMenuItems.filter(
        (item) =>
          restrictedIds.includes(item.id) && [1, 2, 3, 4, 5, 6, 18, 19, 20].includes(item.id)
      );
      configureItems = allMenuItems.filter(
        (item) =>
          restrictedIds.includes(item.id) && [7, 8, 9, 10, 11, 12, 13, 16, 17, 21, 22].includes(item.id)
      );
    } else {
      mainItems = allMenuItems.filter(
        (item) =>
          nonRestrictedIds.includes(item.id) && [1, 2, 3, 4, 5, 6, 18, 19, 20].includes(item.id)
      );
      configureItems = allMenuItems.filter(
        (item) =>
          nonRestrictedIds.includes(item.id) && [7, 8, 9, 10, 11, 12, 13, 16, 17, 21, 22].includes(item.id)
      );
    }

    const metisMenu = this.isOnRestrictedPages()
      ? [baseMenu[0], ...mainItems]
      : [baseMenu[0], ...mainItems, baseMenu[1], ...configureItems];

    this.setState({ metisMenu });
  };

  handleToggle = (isOpen) => {
    this.setState({ showDropdown: isOpen });
  };

  closeDropdown = () => {
    this.setState({ showDropdown: false });
  };

  toggleSubMenu(e) {
    let menucClass = "";
    if (e.itemId) {
      const subClass = e.items.map((menuItem) => {
        if (["main", "app", "extra", "ui"].includes(menuItem.id)) {
          menucClass = "header";
        }
        menucClass = menuItem.to === this.props.location.pathname ? "" : "collapse";
        return menucClass;
      });
      return subClass;
    } else {
      return e.visible ? "collapse" : "metismenu";
    }
  }

  minisidebarMouseOver() {
    this.props.setMiniSidebarMenuOn(false);
    this.props.setMiniHover(true);
  }

  minisidebarMouseOut() {
    this.props.setMiniSidebarMenuOn(true);
    this.props.setMiniHover(false);
  }

  componentDidMount() {
    this.updateMenuItems();

    document.querySelectorAll("li").forEach((el) => {
      if (["Main", "App", "UI Elements", "Extra", "Configure"].includes(el.innerText)) {
        el.className = "header";
      } else {
        el.className = "header_sub";
      }
    });

    // Cleanup listeners on unmount
    this.cleanupListeners = () => {
      const sidebar = document.getElementById("left-sidebar");
      if (sidebar) {
        sidebar.removeEventListener("mouseover", this.minisidebarMouseOver);
        sidebar.removeEventListener("mouseout", this.minisidebarMouseOut);
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.updateMenuItems();
    }

    // Re-attach hover listeners when miniSidebar or miniHover changes
    const sidebar = document.getElementById("left-sidebar");
    if (sidebar) {
      if (this.props.miniSidebar && !prevProps.miniSidebar) {
        sidebar.addEventListener("mouseover", this.minisidebarMouseOver);
      }
      if (this.props.miniHover && !prevProps.miniHover) {
        sidebar.addEventListener("mouseout", this.minisidebarMouseOut);
      }
    }
  }

  componentWillUnmount() {
    if (this.cleanupListeners) this.cleanupListeners();
  }

  render() {
    const { miniSideMenuOn, miniHover, offcanvas } = this.props;

    return (
      <>
        {/* Sidebar */}
        <div
          id="left-sidebar"
          className={`sidebar${
            miniSideMenuOn ? " mini_sidebar_on" : ""
          }${offcanvas ? " offcanvas-active" : ""}`}
        >
          <MenuHeader />
          <div className="sidebar-scroll">
            <nav id="left-sidebar-nav" className="sidebar-nav">
              <MetisMenu
                content={this.state.metisMenu}
                noBuiltInClassNames={true}
                classNameItemActive="active"
                classNameContainer={(e) => this.toggleSubMenu(e)}
                classNameContainerVisible="in"
                iconNamePrefix=""
                LinkComponent={(e) => <DefaultLink itemProps={e} />}
              />
            </nav>
          </div>
        </div>

        {/* Overlay for Offcanvas (Tablet/Mobile) */}
        {offcanvas && (
          <div
            className="sidebar-overlay"
            onClick={() => this.props.setOffcanvas(false)}
            style={{
            //   position: "fixed",
            //   top: 0,
            //   left: 0,
            //   width: "100%",
            //   height: "100%",
            //   background: "rgba(0, 0, 0, 0.5)",
            //   zIndex: 1040,
            }}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  offcanvas: state.settings.offcanvas,
  miniSidebar: state.settings.miniSidebar,
  miniSideMenuOn: state.settings.miniSideMenuOn,
  miniHover: state.settings.miniHover,
});

const mapDispatchToProps = (dispatch) => ({
  setOffcanvas: (value) => dispatch(setOffcanvas(value)),
  setMiniSidebarMenuOn: (value) => dispatch(setMiniSidebarMenuOn(value)),
  setMiniHover: (value) => dispatch(setMiniHover(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Menu);